import { render, staticRenderFns } from "./Categories_realtime.vue?vue&type=template&id=4daf068a&"
import script from "./Categories_realtime.vue?vue&type=script&lang=js&"
export * from "./Categories_realtime.vue?vue&type=script&lang=js&"
import style0 from "./Categories_realtime.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports